import React, { memo, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';

import CommonMenu from '../../../../components/common-menu/CommonMenu';
import { changeEditableUser } from '../../../../redux/user-management/userManagementReducer';

const UserTablePopper = ({ user, onBlockUserModalOpen, onDeleteUserModalOpen, onChangePasswordModalOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation('userManagement');

  const { id, enabled } = user;

  const handleEditUser = useCallback(() => {
    dispatch(changeEditableUser(user));
    navigate(`/users/edit/${id}`);
  }, [navigate, user, dispatch, id]);

  const handleChangePasswordClick = useCallback(() => {
    onChangePasswordModalOpen();
  }, [onChangePasswordModalOpen]);

  const handleBlockClick = useCallback(() => {
    onBlockUserModalOpen();
  }, [onBlockUserModalOpen]);

  const handleDeleteClick = useCallback(() => {
    onDeleteUserModalOpen();
  }, [onDeleteUserModalOpen]);

  const USER_MENU_OPTIONS = useMemo(() => {
    return [
      {
        label: t('changePassword'),
        value: handleChangePasswordClick,
      },
      {
        label: enabled ? t('disable') : t('enable'),
        value: handleBlockClick,
      },
      {
        label: t('delete'),
        value: handleDeleteClick,
      },
      {
        label: t('edit'),
        value: handleEditUser,
      },
    ];
  }, [t, handleChangePasswordClick, handleEditUser, handleBlockClick, handleDeleteClick, enabled]);

  const handleSelect = useCallback((selectedItem) => {
    selectedItem.value();
  }, []);

  return <CommonMenu options={USER_MENU_OPTIONS} onSelect={handleSelect} />;
};

export default memo(UserTablePopper);
